// import 'chartjs-adapter-date-fns'
import {
  BarController,
  BarElement,
  CategoryScale,
  Chart,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  TimeScale,
  Tooltip,
} from 'chart.js'

export default {
  install () {
    Chart.register(
      BarController,
      BarElement,
      CategoryScale,
      Legend,
      LinearScale,
      LineController,
      LineElement,
      PointElement,
      TimeScale,
      Tooltip,
    )
    // app.component('AppBarChart', AppBarChart)
    // app.component('AppLineChart', AppLineChart)
  },
}

